import { BaseComponent } from '../base-component.js';

export class AgAlert extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-alert"><slot></slot></div>`;
  }
}

customElements.define('ag-alert', AgAlert);
